// Bare /liff/events entry — registered LIFF endpoint URL for event.
// Lists recent / completed patrol events for the user to drill into.

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLiff } from "../../../liff/index.js";
import { fetchOfficerTasks, type OfficerTasksData } from "../../../liff/api.js";
import { MobileShell, Card, CardHeader, MobileSpinner, EmptyMobile } from "../../../liff/components/Mobile.js";

export function EventPickerPage(): React.ReactElement {
  const { session } = useLiff();
  const nav = useNavigate();
  const [data, setData] = useState<OfficerTasksData | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!session) return;
    fetchOfficerTasks(session.tenant_id, session.session_token)
      .then(setData)
      .catch((e: unknown) => setError((e as Error).message));
  }, [session]);

  if (error) return (
    <MobileShell title="無法載入巡邏事件"><Card><p className="text-sm text-danger">{error}</p></Card></MobileShell>
  );
  if (!data) return <MobileSpinner />;
  // tasks_today with status=done are completed events the officer can review.
  const completed = data.tasks_today.filter((t) => t.status === "done");
  return (
    <MobileShell title="巡邏事件" subtitle="點選事件以檢視已上鎖證據">
      <Card>
        <CardHeader title={data.shift_label || "本班事件"} hint={`${completed.length} 筆`} />
        {completed.length === 0 ? (
          <EmptyMobile title="尚未產生事件" />
        ) : (
          <ul className="divide-y divide-border-subtle -my-2">
            {completed.map((e) => (
              <li key={e.id}>
                <button
                  onClick={() => nav(`/liff/events/${encodeURIComponent(e.id)}`)}
                  className="w-full text-left py-3 flex items-center justify-between gap-2"
                >
                  <div className="min-w-0">
                    <p className="text-sm font-medium truncate">{e.location_label}</p>
                    <p className="text-[11px] text-text-muted">{e.site_name} · {e.expected_at_local}</p>
                  </div>
                  <span className="text-text-muted text-xs">→</span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </MobileShell>
  );
}
